<template>
    <div>
        <subscription-url v-if="isUrlSubscription" />
        <subscription-list v-if="isSubscriptionList" />
    </div>
</template>
<script>
import SubscriptionUrl from "./Url.vue";
import SubscriptionList from "./List.vue";

export default {
    components: {
        SubscriptionUrl, SubscriptionList
    },
    computed: {
        subscriptionDetails() {
            return window.subscriptionDetails;
        },
        isUrlSubscription() {
            return this.subscriptionDetails && !this.isSubscriptionList
        },
        isSubscriptionList() {
            return this.subscriptionDetails && this.subscriptionDetails.type==='list'
        },
    },
    created() {
        // check if this is wrong url and we need to do some actions
        if (!window.subscriptionDetails && window.unsubscribeDetails) {
            this.$router.push({'name': 'unsubscribe'})
        }
    }
}
</script>
